import { lazy } from 'react';

const trialBalance = lazy(() => import('../pages/TrialBalanceV2'));

const trialBalanceV2Route = {
  public: [],
  auth: [
    {
      name: 'trial_balance_v2',
      path: '/finance-and-accounting/:tab?',
      component: trialBalance,
    },
  ],
};

export default trialBalanceV2Route;
